import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { TriangleAlert } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../../modules/translation/TranslationContext';

interface EntityWarningBannerProps {
  entityLabel: string;
  onRetry: () => void;
  isRetrying: boolean;
}

function EntityWarningBanner({ entityLabel, onRetry, isRetrying }: EntityWarningBannerProps) {
  const { translate } = useTranslation();

  return (
    <Stack
      direction="row"
      role="alert"
      test-id="global-search-warning-banner"
      sx={(theme) => ({
        alignItems: 'center',
        gap: 1,
        flexShrink: 0,
        px: 1,
        py: 0.5,
        borderRadius: `${theme.shape.borderRadiusLg}px`,
        backgroundColor: theme.palette.action.hover,
      })}
    >
      <Box sx={{ display: 'inline-flex', flexShrink: 0, color: 'warning.main' }}>
        <Icon icon={TriangleAlert} size="md" />
      </Box>
      <Typography variant="body2" color="text.secondary" noWrap sx={{ flex: 1, minWidth: 0 }}>
        {translate(LangEnum.GLOBAL_SEARCH_WARNING_MESSAGE, { entity: entityLabel })}
      </Typography>
      <Button
        variant="text"
        color="secondary"
        size="small"
        testId="global-search-warning-retry"
        disabled={isRetrying}
        onClick={onRetry}
      >
        {translate(LangEnum.GLOBAL_SEARCH_WARNING_RETRY)}
      </Button>
    </Stack>
  );
}

export default EntityWarningBanner;
